import React from "react";
import {FormLabel, Grid, Chip} from "@material-ui/core";


function AccessLevel(props) {
    const { roleList } =  props;
    return (
        <Grid item>
            <FormLabel component="legend">Access Levels</FormLabel>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={8}>
                {
                    roleList && roleList.map(role =>(
                        <Grid item key={role}>
                            <Chip label={role} className={props.classes.chip} variant="outlined"/>
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>
    );
}

export default AccessLevel;